export default __webpack_public_path__ + "static/media/LocationBlack.b360551d.svg";